import React from 'react';
import { SvgIcon } from './svg-icon';

export const History = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M21 10.12H14.2195L16.9597 7.3C14.2295 4.6 9.80924 4.5 7.07906 7.2C4.34887 9.91 4.34887 14.28 7.07906 16.99C9.80924 19.7 14.2295 19.7 16.9597 16.99C18.3198 15.65 18.9999 14.08 18.9999 12.1H21C21 14.08 20.1199 16.65 18.3598 18.39C14.8496 21.87 9.1492 21.87 5.63896 18.39C2.13873 14.92 2.10872 9.28 5.61896 5.81C9.1292 2.34 14.7596 2.34 18.2698 5.81L21 3V10.12ZM12.4994 8V12.25L15.9997 14.33L15.2796 15.54L10.9993 13V8H12.4994Z" />
  </SvgIcon>
);
